import { render, staticRenderFns } from "./AtalhosRapidos.vue?vue&type=template&id=270f1460&"
import script from "./AtalhosRapidos.vue?vue&type=script&lang=js&"
export * from "./AtalhosRapidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports